// extracted by mini-css-extract-plugin
module.exports = {"component":"image-media-block_component__pgpAy","column":"image-media-block_column___YRDe","image":"image-media-block_image__W8S_9","caption":"image-media-block_caption__ElWVc"};